/** The part of `window.location` a room navigation needs — injectable for tests. */
export interface RoomNavigationTarget {
  readonly href: string;
  readonly pathname: string;
  hash: string;
  assign(url: string): void;
  reload(): void;
}

/**
 * Opens a `/<game>/#room=CODE` link so the destination app's `#room=`
 * resolution actually runs. Assigning `location.href` to a URL that differs
 * only by its hash is a same-document fragment navigation — no page load, so
 * a player accepting an invite while already inside that game was left on
 * the menu until they reloaded by hand. Same path → set the hash and reload;
 * a different path is a normal navigation that loads the page anyway.
 */
export function openRoomLink(url: string, location: RoomNavigationTarget = window.location): void {
  const target = new URL(url, location.href);
  const current = new URL(location.href);
  if (target.origin === current.origin && target.pathname === current.pathname) {
    location.hash = target.hash;
    location.reload();
    return;
  }
  location.assign(target.href);
}
